import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type UpdatePasswordCredentialsDTO = {
 password:string
 confirmPassword:string
 token:string | null
};

export const updatePassword = (data: UpdatePasswordCredentialsDTO) => {
  return axios.post('/password/update', data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof updatePassword>;
};

export const useUpdatePassword = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Password Updated',
      });
    },
    ...config,
    mutationFn: updatePassword,
  });
};
